module.exports = __webpack_public_path__ + "assets/sepa-w.f9b0a23a.png";